"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcTabMenuItem = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AcTabMenuItem = function (_a) {
    var type = _a.type, id = _a.id, title = _a.title, icon = _a.icon, iconStyle = _a.iconStyle, _b = _a.textClassName, textClassName = _b === void 0 ? 'd-block text-center text-primary font-weight-bold' : _b, expandableMenu = _a.expandableMenu, path = _a.path, active = _a.active, actionIcon = _a.actionIcon, _c = _a.height, height = _c === void 0 ? 80 : _c, onClick = _a.onClick, onClickEdit = _a.onClickEdit;
    var history = react_router_dom_1.useHistory();
    var _onClick = function () {
        if (!active) {
            onClick === null || onClick === void 0 ? void 0 : onClick(id);
            if (path)
                history.push(path);
        }
    };
    var _onClickEdit = function () {
        if (title) {
            // @ts-ignore
            onClickEdit === null || onClickEdit === void 0 ? void 0 : onClickEdit(id, title);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: clsx_1.default("d-flex align-items-center justify-content-center tab-menu-item " + (expandableMenu ? 'flex-grow-1' : ''), type, {
                clickable: !active && (path || onClick),
                active: active,
            }), style: { height: height }, onClick: _onClick },
            icon && react_1.default.createElement("i", { style: iconStyle, className: icon + " mr-1" }),
            react_1.default.createElement("span", { className: textClassName }, title)),
        actionIcon && (react_1.default.createElement("div", { className: clsx_1.default('d-flex align-items-center justify-content-center tab-menu-item'), onClick: _onClickEdit },
            react_1.default.createElement("i", { style: iconStyle, className: actionIcon })))));
};
exports.AcTabMenuItem = AcTabMenuItem;
exports.AcTabMenuItem.displayName = 'AcTabMenuItem';
//# sourceMappingURL=AcTabMenuItem.js.map